import { useNavigate, useParams } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'
import { ApprovePromotionPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Content from './_Content'

const ApprovePromotionPage = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const employeeId = String(params.id)
  const requestedContractVersionId = String(params.contractVersionId)
  const { company } = useCurrentSession()

  const backPath = navigation.employees.id.contractVersions.fullPath({
    id: employeeId,
  })

  const { data, loading } = useQuery(ApprovePromotionPageDocument, {
    variables: {
      companyId: company.id,
      contractVersionRequestIds: [requestedContractVersionId],
      employeeId: employeeId,
    },
  })

  const contractVersionChanges = data?.contracts.contractVersionChangesConnection?.nodes[0]
  const contractVersionRequest = data?.contracts.contractVersionRequestsConnection?.nodes[0] ?? null
  const canSeePage = contractVersionRequest?._policies?.promote.can ?? false
  const hasLegacyJobCatalog =
    data?.features?.featuresConnection?.nodes?.find(
      (feature) => feature.name === 'legacy_job_catalog'
    )?.enabled ?? false
  const hasDevJobCatalogTree = !hasLegacyJobCatalog
  const hasTimeTrackingAnnualisationDailyValue =
    data?.companies.featureAvailabilitiesConnection.nodes.find(
      (feature) => feature.id === Features.time_tracking_annualisation_daily_value
    )?.available ?? false
  const hasDevTimeTrackingWorkableDaysDefinition =
    data?.features.featuresConnection.nodes.find(
      (feature) => feature.name === 'dev_time_tracking_workable_days_definition'
    )?.enabled ?? false

  if (!loading && !contractVersionRequest) {
    navigate(
      navigation.employees.id.contractVersions.fullPath({
        id: employeeId,
      })
    )
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={!contractVersionRequest && !contractVersionChanges}
      authorized={canSeePage || loading}
    >
      {contractVersionRequest && contractVersionChanges && (
        <Content
          backPath={backPath}
          contractVersionRequest={contractVersionRequest}
          contractVersionChanges={contractVersionChanges}
          hasDevJobCatalogTree={hasDevJobCatalogTree}
          hasTimeTrackingAnnualisationDailyValue={hasTimeTrackingAnnualisationDailyValue}
          hasDevTimeTrackingWorkableDaysDefinition={hasDevTimeTrackingWorkableDaysDefinition}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default ApprovePromotionPage
